module.exports = __webpack_public_path__ + "img/customer_design_1.dca02ef.jpg";